import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./portfolio.css";

const Portfolio = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const portfolioItems = [
    {
      id: 1,
      category: "Full-Stack Development",
      title: "Coffee Shop",
      // صورة تعبر عن لوحة تحكم ذكية وشبكات متصلة
      image: "https://www.bing.com/th/id/OIP.KCIsx55ZkDc0cSmJpBytsQHaHa?w=211&h=211&c=8&rs=1&qlt=90&o=6&dpr=1.3&pid=3.1&rm=2", 
      link: "https://hb-khalat.netlify.app/",
      description: "نظام متكامل لإدارة خدمات تقنية المعلومات، يعتمد على Node.js و React و MongoDB، مع نظام تذاكر ودعم فني متطور.",
    },
    {
      id: 2,
      category: "Agricultural Technology", // تم التغيير ليناسب التخصص الزراعي
      title: "Hfno-Plant",
      // صورة تعبر عن التكنولوجيا الزراعية والذكاء الاصطناعي في النباتات
      image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=600&auto=format&fit=crop", 
      link: "https://hfno-plant.netlify.app/", // تأكد من وضع الرابط الكامل هنا
      description: "نظام ذكي موجه لمهندسي الزراعة يساعد في تشخيص أمراض النباتات وتقديم استشارات زراعية دقيقة باستخدام تقنيات تحليل البيانات.",
    },
    {
      id: 3,
      category: "ًWebsite As a Desktop App",
      title: "Website As a Desktop App",
      // صورة تعبر عن الإنتاجية وتنظيم الوقت
      image: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?q=80&w=600&auto=format&fit=crop",
      link: "https://sam-solutions.netlify.app/",
      description: "تطبيق لسطح المكتب مبني باستخدام Java و Spring Framework لإدارة المهام اليومية وتنظيم الوقت بكفاءة.",
    },
    {
      id: 4,
      category: "Cybersecurity",
      title: "Web Vulnerability Scanner",
      // صورة تعبر عن الحماية والأمان الرقمي
      image: "https://th.bing.com/th/id/OIP.6yXjpj8wc3OW0oqQIVonBwHaEJ?w=298&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3",
      link: "",
      description: "أداة بلغة Python لتحليل الثغرات الأمنية في تطبيقات الويب واكتشاف ملفات JSP الخبيثة.",
    },
  ];

  const handleShowModal = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
    setShowModal(false);
  };

  return (
    <section
      id="portfolio"
      className="my-5 p-4 my-5 py-5"
      style={{ paddingTop: "30px" }}
    >
      <div className="mx-auto w-100 text-center mb-5">
        <span className="text-center mb-5">Portfolio</span>
        <h1
          className="text-white mb-3"
          style={{ fontSize: "50px", fontWeight: 600 }}
        >
          My Recent Works
        </h1>
      </div>

      {portfolioItems.map((item) => (
        <div className="p-3 d-flex flex-row" key={item.id}>
          <div  id="biggerDiv" className="d-flex justify-content-between align-items-center w-100 flex-wrap flex-md-row flex-column">
            <div  className="d-flex justify-content-around w-50 flex-wrap">
              <p id="item-cat"
                style={{
                  color: "#9b9db1",
                  textTransform: "uppercase",
                  fontSize: "16px",
                }}
                className="col-2 mx-3"
              >
                {item.category}
              </p>
              <h3 className="text-white mx-3 text-center">{item.title}</h3>
            </div>
            <div className="d-flex justify-content-around justPortfolio align-items-center w-50 flex-wrap">
              <img
                src={item.image}
                className="mx-auto mr-5 img-fluid"
                alt={item.title}
                style={{ borderRadius: "12px", width: "250px", height: "180px", objectFit: "cover", marginRight: "25px", boxShadow: "0 4px 8px rgba(0,0,0,0.3)" }}
              />
              <i
                className="fa-solid fa-plus btn btn-outline-success"
                style={{ fontSize: "40px", cursor: "pointer" }}
                onClick={() => handleShowModal(item)}
              ></i>
            </div>
          </div>
        </div>
      ))}

      {/* Modal */}
  <Modal show={showModal} onHide={handleCloseModal} centered style={{ marginTop: "50px" }}>
        <Modal.Header closeButton className="border-0 custom-red-close">
          <Modal.Title className="fw-bold w-100 text-center">{selectedItem?.title}</Modal.Title>
        </Modal.Header>
      
      <Modal.Body className="text-center">
        <img
          src={selectedItem?.image}
          alt={selectedItem?.title}
          className="img-fluid mb-4"
          style={{ borderRadius: "15px", boxShadow: "0 4px 15px rgba(0,0,0,0.2)" }}
        />
        <p className=" px-2" style={{ lineHeight: "1.8" }}>
          {selectedItem?.description}
        </p>
      </Modal.Body>

      <Modal.Footer className="border-0 d-flex justify-content-center pb-4">
        {/* زر زيارة المشروع */}
        {selectedItem?.link && (
          <a 
            href={selectedItem?.link} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn btn-primary px-4 mx-2"
            style={{ borderRadius: "8px", backgroundColor: "#0d6efd" }}
          >
            Visit Project <i className="fa-solid fa-arrow-up-right-from-square ms-1" style={{fontSize: "12px"}}></i>
          </a>
        )}

        {/* زر الإغلاق */}
        <Button 
          variant="success" 
          className="px-4 mx-2" 
          onClick={handleCloseModal}
          style={{ borderRadius: "8px" }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
    </section>
  );
};

export default Portfolio;
